<div class="media-card-container">
	<h5 *ngIf="label">{{ label | translate }}</h5>
	<div class="media-card" *ngIf="media">
		<ngx-media-thumbnail
			class="media-thumbnail"
			[media]="media"
		></ngx-media-thumbnail>
		<div class="media-title">
			{{ media.title }}
		</div>
	</div>
</div>
